export const woundAssessmentTalliesByLocationActions = {
  populateWoundAssessmentTalliesByLocation:
    "POPULATE_WOUND_ASSESSMENT_TALLIES_BY_LOCATION",
  woundAssessmentTalliesByLocationLoading:
    "DATA_WOUND_ASSESSMENT_TALLIES_BY_LOCATION_LOADING",
  woundAssessmentTalliesByLocationLoadError:
    "DATA_WOUND_ASSESSMENT_TALLIES_BY_LOCATION_LOAD_ERROR"
};
